// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"c9099ac1","416":"9dece61d","624":"d5938e0a","884":"17e9276e","973":"4abaaa98"}[chunkId] + ".chunk.css";
};